module.exports = __webpack_public_path__ + "img/ai.58bed938.svg";